import { MARKETING_EMBED_NAV_CSS_ID, MARKETING_EMBED_NAV_CSS_QA_URL, MARKETING_EMBED_NAV_CSS_URL, MARKETING_EMBED_NAV_SCRIPT_ID, MARKETING_EMBED_NAV_SCRIPT_QA_URL, MARKETING_EMBED_NAV_SCRIPT_URL } from '../components/MarketingNav/MarketingNav.constants';
export function injectMarketingEmbedNav(qa = false) {
  injectMarketingEmbedNavAsset('script', MARKETING_EMBED_NAV_SCRIPT_ID, qa ? MARKETING_EMBED_NAV_SCRIPT_QA_URL : MARKETING_EMBED_NAV_SCRIPT_URL);
  injectMarketingEmbedNavAsset('link', MARKETING_EMBED_NAV_CSS_ID, qa ? MARKETING_EMBED_NAV_CSS_QA_URL : MARKETING_EMBED_NAV_CSS_URL);
}
function injectMarketingEmbedNavAsset(tag, id, src) {
  var _firstEl$parentNode;
  let el;
  if (tag === 'script') {
    el = document.createElement('script');
    el.src = src;
    el.async = true;
    el.defer = true;
  } else {
    el = document.createElement('link');
    el.rel = 'stylesheet';
    el.href = src;
  }
  el.id = id;
  el.onload = () => {
    el.setAttribute('data-loaded', 'true');
  };
  const firstEl = document.getElementsByTagName(tag)[0];
  firstEl === null || firstEl === void 0 || (_firstEl$parentNode = firstEl.parentNode) === null || _firstEl$parentNode === void 0 || _firstEl$parentNode.insertBefore(el, firstEl);
}